<!-- 博客文章 -->
<template>
  <div class='blog-article'>
    <!-- <vue-markdown class="article" :source="content"></vue-markdown> -->
    <!-- <talk></talk> -->
  </div>
</template>

<script>
// import VueMarkdown from 'vue-markdown'
// import talk from '@/article/talk.md'

export default {
  
  name: 'BlogArticle',

  components: {
    // VueMarkdown,
    // talk,
  },
  
  data() {
    return {
      content: '# dsf'
    }
  },
  
  computed: {
    
  },

  watch: {
    
  },

  created() {
    
  },
  
  mounted() {
    
  },
  
  methods: {
    
  },
}
</script>

<style scoped>
</style>
